import { gql } from '@apollo/client';

export const OPEN_PACK_MUTATION = gql`
  mutation OpenPack($data: OpenPackInput!) {
    openPack(data: $data) {
      enqueued
    }
  }
`;
